import React, { FC } from "react";
import { Link } from "react-router-dom";
import { TransferMetricKey } from "../statisticsConfig";
import { formatTransferMetricValue } from "../statisticsUtils";
import ArrowIcon from "../../../icons/ArrowIcon";
import DateInputGradient from "../../../atoms/DateInputGradient/DateInputGradient";
import Select from "../../../atoms/Select/Select";

interface TransferCurrencyTabProps {
    stats: any;
    linkTo: string;

    selectedCurrency: string;
    setSelectedCurrency: (v: string) => void;

    currencyDateFrom: string;
    currencyDateTo: string;
    setCurrencyDateFrom: (v: string) => void;
    setCurrencyDateTo: (v: string) => void;
    onReset: () => void;
}

const DEFAULT_PURCHASE_AMOUNT_CURRENCY = "USDT";
const DEFAULT_SEND_CURRENCY = "USDT";

const TransferCurrencyTab: FC<TransferCurrencyTabProps> = ({
                                                               stats,
                                                               linkTo,
                                                               selectedCurrency,
                                                               setSelectedCurrency,
                                                               currencyDateFrom,
                                                               currencyDateTo,
                                                               setCurrencyDateFrom,
                                                               setCurrencyDateTo,
                                                               onReset
                                                           }) => {
    const renderCurrencyMetricItem = (title: string, metricKey: TransferMetricKey, isMoney: boolean) => {
        const overall = stats?.transfer?.currency?.overall;
        const value = overall?.[metricKey] || 0;

        const periodLabel =
            currencyDateFrom || currencyDateTo
                ? `${currencyDateFrom || "…"} — ${currencyDateTo || "…"}`
                : "за всё время";

        const formatted = formatTransferMetricValue(
            metricKey,
            value,
            isMoney,
            DEFAULT_PURCHASE_AMOUNT_CURRENCY,
            selectedCurrency,
            DEFAULT_SEND_CURRENCY
        );

        return (
            <div className="statistics-items__item" key={`currency-card-${metricKey}`}>
                <Link to={linkTo} className="statistics-items__item-link">
                    <ArrowIcon />
                </Link>
                <div className="statistics-items__item-title">{title}</div>
                <div className="statistics-items__item-list">
                    <div className="statistics-items__item-content">
                        <div className="statistics-items__item-content-counter">
                            <div className="statistics-items__item-content-counter-main">
                                <span>{formatted}</span>
                                <span>
                                    <b>период →</b> {periodLabel}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="statistics-items__filter">
                <div className="statistics-items__filter-row">
                    <div className="statistics-items__filter-field">
                        <Select
                            name="selectedCurrency"
                            placeholder="Валюта"
                            items={(stats?.transfer?.byCurrency?.allTime || [])
                                .filter((r: any) => r?.purchase_currency)
                                .map((r: any) => ({
                                    value: r.purchase_currency,
                                    name: r.purchase_currency
                                }))}
                            defaultValue={selectedCurrency}
                            onChange={(v: any) => setSelectedCurrency(String(v))}
                        />
                    </div>

                    <div className="statistics-items__filter-field">
                        <DateInputGradient
                            name="currencyDateFrom"
                            placeholder="Дата с"
                            value={currencyDateFrom}
                            onChange={(v: any) => setCurrencyDateFrom(v)}
                        />
                    </div>
                    <div className="statistics-items__filter-field">
                        <DateInputGradient
                            name="currencyDateTo"
                            placeholder="Дата по"
                            value={currencyDateTo}
                            onChange={(v: any) => setCurrencyDateTo(v)}
                        />
                    </div>

                    <button type="button" className="statistics-items__transfer-tab" onClick={onReset}>
                        Сбросить
                    </button>
                </div>
            </div>

            <div className="statistics-items__list">
                {renderCurrencyMetricItem("Сумма в рублях", "rub_amount", true)}
                {renderCurrencyMetricItem("Закупки", "purchase_amount", false)}
                {renderCurrencyMetricItem("Прибыль в USDT", "profit_rub", false)}
                {renderCurrencyMetricItem("Перевод", "transfer_amount", false)}
                {renderCurrencyMetricItem("Сумма отправки", "send_amount", false)}
            </div>
        </>
    );
};

export default TransferCurrencyTab;
